import { del } from 'idb-keyval';
import { Component, MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import {
	EasyClaimCaseResponseDto,
	LocalizedCaseUrl,
} from 'src/easyclaim.api.client.typescript/src';
import { IMAGE_CACHE_KEY } from 'src/easyclaim.app.contexts/ImageQueryPersister';
import styled from 'styled-components';

import { FlagIcon } from '../common/FlagIcon';
import { Modal } from '../common/Modal';

import 'flag-icon-css/css/flag-icons.min.css';
import { reportError } from 'src/easyclaim.app.libs/reportError';

interface ChooseLangModalProps {
	caseResponse: EasyClaimCaseResponseDto;
	isOpen: boolean;
	onClose: () => void;
	currentLang?: string;
}

export class ChooseLangModal extends Component<ChooseLangModalProps, {}> {
	modal?: Modal | null;

	getLink(localizedCaseUrl: LocalizedCaseUrl, index: number) {
		if (!!localizedCaseUrl.twoLetterFlagCountryCode && !!localizedCaseUrl.url) {
			const twoLetterFlagCodeString: string = localizedCaseUrl.twoLetterFlagCountryCode;
			const isSameLang = localizedCaseUrl.twoLetterLangCode === this.props.currentLang;
			const changeLanguage = async () => {
				try {
					await del(IMAGE_CACHE_KEY);
					window.location.href = localizedCaseUrl.url!;
				} catch (error) {
					reportError(error, { context: 'ChooseLangModal.getLink.changeLanguage' });
					window.location.href = localizedCaseUrl.url!;
				}
			};
			const handleClick = (e: MouseEvent) => {
				if (isSameLang) return;
				e.preventDefault();
				void changeLanguage();
			};

			return (
				<LangLinkContainer key={index}>
					<Link href={isSameLang ? undefined : localizedCaseUrl.url} onClick={handleClick}>
						<LangContainer>
							<FlagIcon flagCountryCode={twoLetterFlagCodeString}></FlagIcon>
						</LangContainer>
					</Link>
				</LangLinkContainer>
			);
		}
	}

	render() {
		return (
			<Modal
				isOpen={this.props.isOpen}
				closeOnBackdropClick={true}
				onClose={this.props.onClose}
				header={
					<h2 className="chooseLang-title">
						<FormattedMessage id="chooseLang.headline" />
					</h2>
				}
				ref={(r) => (this.modal = r)}
				footer={
					<button className="choose-modal-button-close" onClick={this.props.onClose}>
						<FormattedMessage id="button.close" />
					</button>
				}
			>
				<LangSection>
					{this.props.caseResponse.localizedCaseUrls ? (
						this.props.caseResponse.localizedCaseUrls.map((lcl, index) => this.getLink(lcl, index))
					) : (
						<></>
					)}
				</LangSection>
			</Modal>
		);
	}
}

const Link = styled.a`
	text-decoration: underline;
	cursor: pointer;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	:any-link,
	:visited,
	:link {
		color: ${(p) => p.color};
	}
`;

const LangSection = styled.div`
	display: flex;
	flex-wrap: wrap;
`;

const LangContainer = styled.div`
	padding: 0.5rem;
	box-sizing: border-box;
	border: 1px solid #ccc;
	border-radius: 1rem;
	background-color: #e6e6e6;
`;

const LangLinkContainer = styled.div`
	padding: 0.25rem;
	text-align: center;
	width: 50%;
	box-sizing: border-box;
`;
